import { useMutation } from "@tanstack/react-query";

import { useOrdersCache } from "../cache/orders";
import {
  DevCheatOrderPayload,
  DevCheatOrderType,
  DevCheatRoutePayload,
  DevCheatRouteType,
  createDevOrder,
  createDevRoute,
} from "../services/devCheat";

export const useDevCheatMutation = () => {
  const ordersCache = useOrdersCache();

  const createOrder = useMutation({
    mutationFn: async ({
      payload,
      type,
    }: {
      payload: DevCheatOrderPayload;
      type: DevCheatOrderType;
    }) => {
      const response = await createDevOrder(type, payload);
      return response;
    },
    onSuccess: () => {
      ordersCache.invalidateOrdersCache();
    },
  });

  const createRoute = useMutation({
    mutationFn: async ({
      payload,
      type,
    }: {
      payload: DevCheatRoutePayload;
      type: DevCheatRouteType;
    }) => {
      const response = await createDevRoute(type, payload);
      return response;
    },
    onSuccess: () => {
      ordersCache.invalidateOrdersCache();
    },
  });

  return { createOrder, createRoute };
};
